interface DialogTitleBarConfig {
  readonly backgroundColor: string
  readonly borderBottomColor: string
  readonly borderBottomWidth: number
  readonly paddingTop: number
  readonly paddingBottom: number
}

interface DialogContentConfig {
  readonly paddingTop: number
  readonly paddingHorizontal: number
  readonly paddingBottom: number
  readonly backgroundColor: string
}

interface DialogStyleConfig {
  readonly backgroundColor: string
  readonly borderRadius: number
  readonly titleBar: DialogTitleBarConfig
  readonly content: DialogContentConfig
}

export const DEFAULT_DIALOG_STYLES: DialogStyleConfig = {
  backgroundColor: 'rgba(45, 45, 45, 0.98)',
  borderRadius: 2,
  titleBar: {
    backgroundColor: 'rgba(255, 255, 255, 0.02)',
    borderBottomColor: 'rgba(255, 255, 255, 0.08)',
    borderBottomWidth: 1,
    paddingTop: 3,
    paddingBottom: 3,
  },
  content: {
    paddingTop: 5,
    paddingHorizontal: 3,
    paddingBottom: 3,
    backgroundColor: 'transparent',
  },
} as const

export const LIGHT_DIALOG_STYLES: DialogStyleConfig = {
  backgroundColor: '#F3EDE4',
  borderRadius: 2,
  titleBar: {
    backgroundColor: 'rgba(62, 39, 35, 0.02)',
    borderBottomColor: 'rgba(62, 39, 35, 0.08)',
    borderBottomWidth: 1,
    paddingTop: 3,
    paddingBottom: 3,
  },
  content: {
    paddingTop: 5,
    paddingHorizontal: 3,
    paddingBottom: 3,
    backgroundColor: 'transparent',
  },
} as const

export function getDialogStyles(mode: 'light' | 'dark'): DialogStyleConfig {
  return mode === 'dark' ? DEFAULT_DIALOG_STYLES : LIGHT_DIALOG_STYLES
}

export type { DialogStyleConfig, DialogTitleBarConfig, DialogContentConfig }
